import { integer, jsonb, pgTable, text, timestamp, unique } from "drizzle-orm/pg-core";

/** Cached consumer API write responses keyed by Idempotency-Key (scoped per consumer + flow + operation). */
export const idempotencyRecords = pgTable(
  "idempotency_records",
  {
    consumerId: text("consumer_id").notNull(),
    flow: text("flow").notNull(),
    operation: text("operation").notNull(),
    key: text("key").notNull(),
    statusCode: integer("status_code").notNull(),
    responseBody: jsonb("response_body").notNull(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [
    unique("idempotency_records_consumer_flow_op_key_unique").on(
      t.consumerId,
      t.flow,
      t.operation,
      t.key,
    ),
  ],
);
